import React, { useEffect, useRef, useState } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner, Input, Label } from 'reactstrap'

type AddProductsModalProps = {
  isOpen: boolean
  toggle: () => void
  initialCodice?: string
  loading?: boolean
  onConfirm: (codice: string, qta: number) => Promise<void> | void
}

export default function AddProductsModal({
  isOpen,
  toggle,
  initialCodice = '',
  loading = false,
  onConfirm,
}: AddProductsModalProps) {
  const [codice, setCodice] = useState('')
  const [qta, setQta] = useState<number>(1)
  const codiceRef = useRef<HTMLInputElement | null>(null)

  useEffect(() => {
    if (isOpen) {
      setCodice(initialCodice)
      setQta(1)
      setTimeout(() => codiceRef.current?.focus(), 100)
    } else {
      setCodice('')
      setQta(1)
    }
  }, [isOpen, initialCodice])

  const handleConfirm = async () => {
    const c = codice.trim()
    const n = Number(qta)

    if (!c) return
    if (!Number.isFinite(n) || n < 1) return

    await onConfirm(c, n)
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader style={{background:'red', color:'white'}} toggle={toggle}>
        <div style={{maxWidth:'80%'}}>
            Codice non trovato. Vuoi aggiungere il prodotto?
        </div>
      </ModalHeader>

      <ModalBody>
        <div className="mb-3">
          <Label className="mb-1" for="addCodice">
            Codice
          </Label>
          <Input
            id="addCodice"
            innerRef={codiceRef as any}
            value={codice}
            onChange={e => setCodice(e.target.value)}
            placeholder="Inserisci codice..."
            autoComplete="off"
            disabled={loading}
          />
        </div>

        <div>
          <Label className="mb-1" for="addQta">
            Quantità
          </Label>
          <Input
            id="addQta"
            type="text"
            min={1}
            step={1}
            value={qta}
            onChange={e => setQta(Number(e.target.value))}
            disabled={loading}
          />
          <small className="text-muted">Inserisci la quantita da aggiungere.</small>
        </div>
      </ModalBody>

      <ModalFooter className="d-flex justify-content-between">
        <Button color="light" style={{ color: 'black' }} onClick={toggle} disabled={loading}>
          Chiudi
        </Button>
        <Button color="primary" onClick={handleConfirm} disabled={loading || !codice.trim() || qta < 1}>
          {loading ? <Spinner size="sm" /> : 'Aggiungi'}
        </Button>
      </ModalFooter>
    </Modal>
  )
}
